import api from "./api";

// Fetch score breakdown for an assignment (or other entity)
export const getScoreBreakdown = (assignmentId: string | number, type: string = "assignment") =>
  api.get(`score-breakdown/${assignmentId}/?type=${type}`).then((r) => r.data);
